import { render, staticRenderFns } from "./AdvancedBlock.vue?vue&type=template&id=a3649338&scoped=true&"
import script from "./AdvancedBlock.vue?vue&type=script&lang=js&"
export * from "./AdvancedBlock.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedBlock.vue?vue&type=style&index=0&id=a3649338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3649338",
  null
  
)

export default component.exports